import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { logError } from '@utils/errorLogging';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';
import { ToastType } from '@components';
import { OrderViewingResponse } from '@mobileStore/order/types';

import { MobileOfficeDetail, UserViewModel } from './types';

export const getOrderViewingApi = async (
  orderId: number,
): Promise<OrderViewingResponse | null> => {
  try {
    return (await apiClient.post(
      `order/viewing/${orderId}`,
      {},
    )) as unknown as OrderViewingResponse;
  } catch (error) {
    handleToast(ToastType.Error, 'Failed to fetch order viewing data');
    return null;
  }
};

export async function fetchMobileOfficeDetail(officeId: number) {
  try {
    const response: V4ApiResponse<MobileOfficeDetail> = await apiClient.get(
      `/office/${officeId}`,
    );
    return response.isSuccess ? response.value : null;
  } catch (error: unknown) {
    logError('fetchMobileOfficeDetail', error as Error);
  }
}

export async function fetchUser(): Promise<UserViewModel> {
  try {
    const response: V4ApiResponse<UserViewModel> = await apiClient.get('/User');

    if (!response.isSuccess) {
      throw new Error(response.errors[0]?.message ?? 'Not logged in!');
    }

    return response.value;
  } catch (error: unknown) {
    logError('fetchUser', error as Error);
    throw createError(error, 'Failed to fetch user');
  }
}
